<template>
  <wgu-map-overlay
    overlayId="tooltip-gemeinden"
    :visible=false
    autoPan
    :autoPanDuration="250"
    :offset="[0, 25]"
    positioning="top-center"
  >
    <v-card
      width="auto"
      slot-scope="{feature}"
      v-if="feature"
      style='border: 1px solid #ec0016;'
    >
    <v-btn
      elevation="2"
      icon
      small
      style="float:right; vertical-align: top;"
      @click="closeTooltip()"
    >
    <v-icon>close</v-icon>
    </v-btn>
      <v-card-title>
        <span style>
          {{ $t('tooltips.gemeindenTitel') }}
        </span >
      </v-card-title>
      <v-card-subtitle>
        <span class="text-subtitle-1 secondary--text">
         {{ feature.get('city_name') }}
        </span>
        <br />

        <span>
         {{ feature.get('name_lkr') }}
        </span>
        <br />

        <span>
         {{ $t('tooltips.bevoelkerung') + Number(feature.get('bevoelkerung')).toLocaleString() }}
        </span>
        <br />
        <br />

        <span>
        <a :href="parseUrl(feature.get('wp_url'))" target="_blank">{{ $t('tooltips.waermeplan_link')}}</a>
        <!-- <a :href="feature.get('wp_url')" target="_blank">{{$('tooltips.waermeplan_link')}}</a> -->
        </span>
        <br />
        <br />

        <span>
         {{ $t('tooltips.datum_veroeffentlichung') + parseDate(feature.get('veroeffentlicht')) }}
        </span>
        <br />

        <span>
         {{ $t('tooltips.vereinfacht_bool') + parseBool(feature.get('bl_vereinfacht')) }}
        </span>
        <br />

        <span>
         {{ $t('tooltips.verkuerzt_bool') + parseBool(feature.get('bl_verkuerzt')) }}
        </span>
        <br />

        <span>
         {{ $t('tooltips.konvoi_bool') +  parseBool(feature.get('bl_konvoi')) }}
        </span>
        <br />

        <span v-if="feature.get('bl_konvoi') === true">
         {{ $t('tooltips.konvoi_nachbarn') + parseConvoy(feature.get('convoy_nachbarn')) }}
        </span>
        <span v-else>
        {{ $t('tooltips.konvoi_nachbarn') + $t('tooltips.keine_konvoi_nachbarn') }}
       </span>
        <br>
          <span v-if="feature.get('bl_measures') === true">
          <v-btn
            @click="passCity(feature.get('city_name'))"
            class="mt-4"
            color="primary"
          >
          {{ $t('tooltips.openMeasures') }}
          </v-btn>
        </span>
      </v-card-subtitle>
    </v-card>
  </wgu-map-overlay>
</template>

<script>
import MapOverlay from '../../src/components/modulecore/MapOverlay.vue';
import { WguEventBus } from '../../src/WguEventBus';

export default {
  name: 'tooltip-gemeinden',
  components: {
    'wgu-map-overlay': MapOverlay
  },
  methods: {
    passCity (city) {
      WguEventBus.$emit('vue-table-visibility-change', true);
      setTimeout(function () {
        WguEventBus.$emit('city-value', city); // Emit the city value
      }, 100);
    },
    closeTooltip () {
      WguEventBus.$emit('tooltip-gemeinden-update-overlay', false);
      setTimeout(function () {
        WguEventBus.$emit('city-value', '');
      }, 100);
    },
    parseConvoy (data) {
      if (!data) return '';
      // Null to empty string
      const str = String(data)
      // Read as json so join works
      return JSON.parse(str).join(', ')
    },
    parseBool (data) {
      const bl = JSON.parse(data);
      if (bl) return 'Ja';
      else return 'Nein';
    },
    parseDate (dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('de-DE');
    },
    parseUrl (url) {
      const parts = url.split('/');
      return './uploads/wp/' + parts[parts.length - 1];
    }
  }
}
</script>
